import React from "react";
import { Route, Switch } from "react-router-dom";
import useFlash from "go-alert/AlertMessage";
import { SegmentContext, SegmentListService } from "go-segment/context";
import { userApiSegment } from "../../../../services/Api/User/userApiSegment";
import UserDashboardPage from "./pages/Dashboard";
import UserLogsPage from "./pages/Logs";
import UserProfilePage from "./pages/Profile";

const UserPage = () => {
	const segmentPath = `/segments`;
	const { addFlash } = useFlash();

	return (
		<SegmentContext.Provider
			value={
				new SegmentListService(
					{
						saveSegment: userApiSegment.saveSegment,
						removeSegment: userApiSegment.removeSegment,
						getSegments: userApiSegment.getSegments,
						restoreSegment: userApiSegment.restoreSegment,
						updateSegment: userApiSegment.updateSegment,
						updateSegments: userApiSegment.updateSegments,
						setAsDefault: userApiSegment.setSegmentAsDefault,
						setNotDefault: userApiSegment.setSegmentNotDefault,
					},
					segmentPath,
					userApiSegment.getListInfo,
					addFlash
				)
			}
		>
			<Switch>
				<Route path={"/profile"} component={UserProfilePage} />
				<Route path={"/logs"} component={UserLogsPage} />
				<Route path={["/", "/dashboard"]} component={UserDashboardPage} />
			</Switch>
		</SegmentContext.Provider>
	);
};

export default UserPage;
